export default __webpack_public_path__ + "images/1464d3478870fd598cd6b1cd190fc6ea-menu-cat-treat.svg";